import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { txnStatusFailure, txnStatusSuccess } from '../../actions/InfluencerCampaignActions/txnStatusActions';

function* txnStatus({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.txnStatus,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("TXN_STATUS_SUCCESS status :", response.data.status);
        console.log("TXN_STATUS_SUCCESS data :", response.data.response);
        console.log("TXN_STATUS_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            txnStatusSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("TXN_STATUS_FAILURE status :", error?.response?.status);
        console.log("TXN_STATUS_FAILURE data:", error?.response?.data);
        console.log("TXN_STATUS_FAILURE error :", error);
        console.log('====================================');
        yield put(txnStatusFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* txnStatusSaga() {
    yield takeLatest(actionTypes.TXN_STATUS_REQUEST, txnStatus);
}

export default txnStatusSaga;
